<template>
  <div class="step3">
    <h2 class="access_hidden">입금정보 입력</h2>
    <exchange-info />
    <template v-if="exchangeInit.isIdentityRegistered === 0">
      <exchange-user-identity-no @update="(val) => (identityNo = val)"></exchange-user-identity-no>
    </template>
    <template v-if="!exchangeInit.isIdentityRegistered !== 0">
      <exchange-user />
    </template>
    <exchange-contact />
    <exchange-account-view v-if="isDisplayAccount" />
    <exchange-account v-else />

    <div>
      <template v-if="exchangeInit.isIdentityRegistered === 0">
        <div class="user_info_form register_agree">
          <div class="agree">
            <v-icon clsName="icon_agree" />
            개인정보 수집 및 이용 안내
            <v-button
              class="btn_open"
              @handleClick="agreeLayerChange(3)"
              text="개인정보 수집 및 이용 안내"
              :textHide="true"
            />
          </div>
        </div>
      </template>
      <agree-layer @custom-change="agreeLayerChange(0)" :state="agreeLayer" />
    </div>
    <div class="bt">
      <template v-if="exchangeInit.isIdentityRegistered === 0">
        <v-button
          @handleClick="handleClick()"
          class="btn01"
          text="신청완료"
          :disabled="!exchangeBtnDisabled || identityNo.isState === false"
        />
      </template>
      <template v-else>
        <v-button
          @handleClick="handleClick()"
          class="btn01"
          text="신청완료"
          :disabled="!exchangeBtnDisabled"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ExchangeInfo from '@/components/modules/exchange/ExchangeInfo';
import ExchangeUser from '@/components/modules/exchange/ExchangeUser';
import ExchangeUserIdentityNo from '@/components/modules/exchange/ExchangeUserIdentityNo';
import ExchangeContact from '@/components/modules/exchange/ExchangeContact';
import ExchangeAccountView from '@/components/modules/exchange/ExchangeAccountView';
import ExchangeAccount from '@/components/modules/exchange/ExchangeAccount';
import VButton from '@/components/atoms/VButton';
import VIcon from '@/components/atoms/VIcon';
import { pointErrorMsg } from '@/utils/errorMsg';
import eventBus from '@/utils/eventBus';
import { selectOpenModal } from '@/utils';
import AgreeLayer from '@/components/modules/common/AgreeLayer';

export default {
  components: {
    ExchangeInfo,
    ExchangeUser,
    ExchangeUserIdentityNo,
    ExchangeContact,
    ExchangeAccountView,
    ExchangeAccount,
    VButton,
    VIcon,
    AgreeLayer,
  },
  data() {
    return {
      identityNo: {
        isState: false,
        idNo: '',
      },
      bankCode: '',
      accountNo: '',
      agreeLayer: 0,
    };
  },
  computed: {
    ...mapGetters(['isExchangeIframe']),
    ...mapGetters('exchange', [
      'exchangeInit',
      'isDisplayAccount',
      'isStateAccount',
      'exchangeBtnDisabled',
      'exchangeRequest',
    ]),
  },
  async created() {
    if (this.$route.params.serviceUrl) {
      this.setServiceUrl(this.$route.params.serviceUrl);
    }
    await this.getPointInfo();
    eventBus.$emit('scrollUpdate');
  },
  beforeDestroy() {
    eventBus.$emit('scrollTop');
  },
  methods: {
    ...mapActions(['setServiceUrl']),
    ...mapActions('modal', ['openModal']),
    ...mapActions('point', ['getPointInfo']),
    ...mapActions('exchange', ['setExchangeRequest', 'setExchangeStep']),
    iframeModalCertified() {
      if (this.isExchangeIframe) {
        window.parent.postMessage({ event: 'iframeModalCertified' }, '*');
      } else {
        this.openModal({
          type: 'confirm',
          message: '장시간 이용이 없어 인증이 만료되었습니다.<br/>처음부터 다시 진행해주세요.',
          callback: () => {
            this.$router.replace({ name: 'Step1' });
          },
        });
      }
    },
    async handleClick() {
      const apiReturn = await this.setExchangeRequest({ ...this.exchangeRequest, idNo: this.identityNo.idNo });
      if (!this.btnDisabled) {
        if (apiReturn.code === 0) {
          this.setExchangeStep('step4');
          this.$router.replace({ name: 'Step4' });
        } else if (apiReturn.code === 3007) {
          this.iframeModalCertified();
        } else {
          selectOpenModal(pointErrorMsg(apiReturn.code));
        }
      }
    },
    agreeLayerChange(val) {
      this.agreeLayer = val;
    },
  },
};
</script>
